import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from "react-router-dom"; // Importa Link de react-router-dom

// Importa los iconos de Material-UI
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import SendIcon from '@mui/icons-material/Send';
import CollectionsIcon from '@mui/icons-material/Collections';
import PersonIcon from '@mui/icons-material/Person';
import Logotipo from "../../assets/logo.png"; // Asegúrate de que la ruta sea correcta

import { useAuthStore } from "../../context/useAuthStore";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function SidebarMobileComponent(props: Props) {
  const { open, setOpen } = props;
  const { WorkerData }: any = useAuthStore();
  const isAdmin = WorkerData?.perfil === "admin";

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const listItems = [
    { text: 'Inicio', icon: <HomeIcon />, to: '/dashboard' },
    { text: 'Socios Registrados', icon: <PeopleIcon />, to: '/socios-registrados' },
    { text: 'Solicitudes Nuevos Socios', icon: <PeopleIcon />, to: '/solicitudes-nuevos-socios' },
    { text: 'OTPs no validados', icon: <MarkEmailUnreadIcon />, to: '/otps-validacion' },
    { text: 'Dispositivos para notificaciones', icon: <PhoneAndroidIcon />, to: '/devices-socios-notifications' },
  ];

  const adminListItems = [
    { text: 'Enviar notificaciones', icon: <SendIcon />, to: '/enviar-notificaciones' },
    { text: 'Publicidad Carousel', icon: <CollectionsIcon />, to: '/publicidad-carousel' },
    { text: 'Usuarios del sistema', icon: <PersonIcon />, to: '/adminUsers' },
  ];

  return (
    <div>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 270, backgroundColor: "#000a29", height: "100%", color: "#fff" }} role="presentation" onClick={toggleDrawer(false)}>
          <div style={{ padding: "16px", textAlign: "center" }}>
            <img src={Logotipo} alt="Logotipo" className="img-fluid mb-3" />
          </div>
          <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />
          <List>
            {listItems.map((item, index) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton component={Link} to={item.to} sx={{ color: "#fff" }}>
                  <ListItemIcon sx={{ color: "#fff" }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
            {isAdmin && (
              <>
                <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />
                {adminListItems.map((item, index) => (
                  <ListItem key={item.text} disablePadding>
                    <ListItemButton component={Link} to={item.to} sx={{ color: "#fff" }}>
                      <ListItemIcon sx={{ color: "#fff" }}>
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText primary={item.text} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </>
            )}
          </List>
        </Box>
      </Drawer>
    </div>
  );
}